export const convertMetreToKm = (value: number) => value / 1000;
